
import React from 'react';

export const ArrowUpRightIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    north_east
  </span>
);